import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mail-checked",
  "use": "mail-checked-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"mail-checked\"><path d=\"M644.309 538.55L576 480l189.538-162.462-25.846-25.846L464 528 188.308 291.692l-25.846 25.846L352 480 162.462 642.462l25.846 25.846L380 504l84 72 84-72 78.121 66.961C614.476 596.922 608 625.704 608 656c0 28.349 5.671 55.373 15.941 80H128.115C92.472 736 64 707.431 64 672.19V287.81C64 252.625 92.705 224 128.115 224h671.77C835.528 224 864 252.569 864 287.81v165.756c-15.409-3.64-31.479-5.566-48-5.566-71.296 0-134.214 35.871-171.691 90.55zM816 832c97.202 0 176-78.798 176-176s-78.798-176-176-176-176 78.798-176 176 78.798 176 176 176zm-16-88.235l-75.314-75.314 23.431-23.431 51.882 51.882 99.882-99.882 23.431 23.431-123.314 123.314z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mail-checked.svg
// module id = vLN1
// module chunks = 1